<xi-drawer
  #drawer
  [open]="open()"
  [interceptClose]="true"
  (onClose)="cancel()"
  color="CX"
  [silverBg]="true"
>
  <ng-container *transloco="let t; read: 'download-center'">
    <div slot="title">{{ t('download-center') }}</div>
    <div slot="body">
      <div class="download-center-table__container">
        <div class="download-center-table__header">
          <div class="header-title">
            <h3>{{ t('available-downloads') }}</h3>
            @if (preferencesService.hasDownloadWarningShow) {
              <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-warning_filled"></mat-icon>
              <small class="download-warning-text">
                {{ t('download-warning-text') }}
              </small>
            }
          </div>
          @if (showStorageAvailable) {
            <span class="storage-info">
              @if (storageAvailable) {
                <span class="storage-available"
                  >{{ t('storage-space-available') }} <b>{{ storageAmount }}</b>
                </span>
              }
              @if (!storageAvailable) {
                <span class="warning-color">{{ t('exceeded-allotted-memory') }}</span>
              }
            </span>
          }
        </div>

        @if (isLoading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <div class="download-center-table__column-scroll">
          <table mat-table [dataSource]="tableDataSource" class="download-center-table__table">
            <ng-container matColumnDef="name">
              <th class="download-center-table__name-header" mat-header-cell *matHeaderCellDef>
                {{ t('name') }}
              </th>
              <td mat-cell *matCellDef="let element">{{ element.taskPayload.filename }}</td>
            </ng-container>

            <ng-container matColumnDef="user">
              <th class="download-center-table__user-header" mat-header-cell *matHeaderCellDef>
                {{ t('user') }}
              </th>
              <td mat-cell *matCellDef="let element">{{ usersById.get(element.userId) }}</td>
            </ng-container>

            <ng-container matColumnDef="starttime">
              <th class="download-center-table__starttime-header" mat-header-cell *matHeaderCellDef>
                {{ t('start-time') }}
              </th>
              <td mat-cell *matCellDef="let element">{{ element.createdAt | lexDate: 'long' }}</td>
            </ng-container>

            <ng-container matColumnDef="source">
              <th class="download-center-table__source-header" mat-header-cell *matHeaderCellDef>
                {{ t('source') }}
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.taskPayload.metadata?.source ?? element.taskPayload.source }}
              </td>
            </ng-container>

            <ng-container matColumnDef="documents">
              <th class="download-center-table__documents-header" mat-header-cell *matHeaderCellDef>
                {{ t('documents') }}
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.taskResult?.docCount || element.taskResult?.count || '-' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="filesize">
              <th class="download-center-table__filesize-header" mat-header-cell *matHeaderCellDef>
                {{ t('file-size') }}
              </th>
              <td mat-cell *matCellDef="let element">
                {{ formatBytes(element.taskResult?.fileSize) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>{{ t('status') }}</th>
              <td mat-cell *matCellDef="let element">
                <div>
                  @switch (element.status) {
                    @case ('PENDING') {
                      <div>{{ t('in-queue') }}</div>
                    }
                    @case ('ERROR') {
                      <div class="download-center-table__error">
                        <xi-icon-button
                          icon="warning_filled"
                          class="download-center-table__warning-icon"
                          color="error"
                          [tooltip]="{
                            text: t('copy-error-text', { errorText: getErrorForTask(element) }),
                            direction: 5,
                          }"
                          (onClick)="copyTaskError(element)"
                        ></xi-icon-button>
                        {{ t('error') }}
                        <xi-icon-button
                          icon="trash"
                          (onClick)="deleteTask(element)"
                        ></xi-icon-button>
                      </div>
                    }
                    @case ('RUNNING') {
                      <div>
                        <span>
                          <img
                            class="indicator-icon"
                            src="assets/icons/warning-yellow-icn-12-px.svg"
                            alt="Error"
                          />
                          {{ element.progress | number: '1.0-0' }}%
                        </span>
                      </div>
                    }
                    @case ('COMPLETE') {
                      <div>
                        <xi-icon-button
                          icon="download"
                          (onClick)="downloadDocument(element)"
                        ></xi-icon-button>
                        <xi-icon-button
                          icon="trash"
                          (onClick)="deleteTask(element)"
                        ></xi-icon-button>
                      </div>
                    }
                  }
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>

        <mat-paginator
          #paginator
          [length]="totalRows"
          [pageIndex]="currentPage"
          [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions"
          (page)="pageChanged($event)"
          aria-label="Select page"
        >
        </mat-paginator>
      </div></div
  ></ng-container>
</xi-drawer>
